const SvgHardware3 = (props) => (
  <>
    <path d="M72 24v48H24V24h48M96 0H0v96h96V0Z" fill={props.p40} />
  </>
);

export default SvgHardware3;
